import { text } from 'd3-request';
import { csvParse } from 'd3-dsv';

const headers = ['id', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

class Data {
  data = []

  format(data) {
    return data.map((d, i) => {
      // const StateCode = d.id.slice(0, 2); 
      const Division = d.id.slice(2, 4);
      // const Element = d.id.slice(4, 6); // possibly check that Element === '06' (PHDI)
      const Year = d.id.slice(6, 10);
      const values = headers.filter(h => h !== 'id').map(k => {
        const date = new Date(Year, k - 1);
        const value = parseFloat(d[k]);
        const group = parseInt(Division, 10);
        return {
          date,
          value,
          group,
        };
      });
      return values;
    })
    .reduce((a, v) => a.concat(v), []) // flatten - might be able to simply updateData function in app.js by starting nested
    .filter(d => d.value !== -99.99); // represents missing value
  }

  load(callback) {
    text(`${process.env.PUBLIC_URL}/data/data.csv`, (text) => {
      const data = csvParse(`${headers.join(',')}\n${text.replace(/[ \t]+/g, ',')}`)
        .filter(d => d.id.slice(0, 2) === '04'); // California only for now
      this.data = this.format(data);
      callback(this.data);
    });
  }
}

export default new Data();



// WEBPACK FOOTER //
// ./src/Data.js